<div class="overflow-y-auto">
	<div class="form pr-5 h-full pt-6">
		<h2 *ngIf="showHeader$ | async">APS</h2>
		<div class="flex-1 h-full">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>

<app-ai-document-processing-loading [matterDocumentType]="matterDocumentType">
	<div class="overflow-y-auto flex justify-center items-center h-full">
		<div class="pdf">
			<app-multiple-url-pdf-viewer
				class="h-full w-full"
				*ngIf="latestAPS?.url"
				matterDocumentType="aps"
				[highlightFields]="apsUpload?.highlightFields"
				[scrollToFieldName]="scrollToFieldName$ | async"
			></app-multiple-url-pdf-viewer>

			<app-container
				type="dark"
				class="h-full"
				*ngIf="!latestAPS?.url"
				[testHook]="testHooks.Container"
			>
				<app-ai-scraping-notification [isUsingIntroduceNotification]="true" />
				<div class="h-full flex-1 flex justify-center items-center">
					<app-sale-file-upload
						type="dropzone"
						class="flex-none"
						label="Upload APS"
						(success)="onFileUploadSuccess($event)"
						[saleId]="matterId"
						[documentName]="fileName"
						[documentType]="APSFileType"
						[runAiScraping]="false"
						*ngIf="!latestAPS?.url"
					></app-sale-file-upload>
				</div>
			</app-container>
		</div>
	</div>
</app-ai-document-processing-loading>
